var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-teacher-status"},[_c('img',{staticClass:"icon-consult ic-no-order",attrs:{"src":require("../../images/consult/expertList/teacher-nomore.png")}}),_vm._t("blank-txt",function(){return [_c('p',{staticClass:"blank-txt",domProps:{"innerHTML":_vm._s(_vm.text)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }